'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'triangle-exclamation';
var width = 512;
var height = 512;
var aliases = [9888,"exclamation-triangle","warning"];
var unicode = 'f071';
var svgPathData = ['M33.5 436.2l209-387.1c9.1-3.3 19.2-3.1 28.2 .3L479.5 436.2c1.3 2.5 1.3 5.5-.2 7.9-1.4 2.4-4.1 3.9-6.9 3.9l-432 0c-2.8 0-5.4-1.5-6.9-3.9-1.4-2.4-1.5-5.4-.2-7.9zm199-60.2a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm.6-174.9l7.4 104c.6 8.4 7.6 14.9 16 14.9s15.4-6.5 16-14.9l7.4-104c1-13.6-9.8-25.1-23.4-25.1s-24.3 11.6-23.4 25.1z', 'M256.5 0c14.7 0 28.2 8.1 35.2 21l216 400c6.7 12.4 6.4 27.4-.8 39.5S486.6 480 472.5 480l-432 0c-14.1 0-27.1-7.4-34.3-19.5s-7.5-27.1-.8-39.5l216-400 2.9-4.6C231.7 6.2 243.7 0 256.5 0zm0 32c-2.4 0-4.7 1.1-6.2 2.9L249 37.1 33.5 436.2c-1.3 2.5-1.3 5.5 .2 7.9 1.4 2.4 4.1 3.9 6.9 3.9l432 0c2.8 0 5.4-1.5 6.9-3.9 1.4-2.4 1.5-5.4 .2-7.9l-216-400c-1.1-1.9-2.8-3.4-4.9-3.9l-2.1-.3zm0 368a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-224c13.6 0 24.3 11.6 23.4 25.1l-7.4 104c-.6 8.4-7.6 14.9-16 14.9s-15.4-6.5-16-14.9l-7.4-104c-1-13.6 9.8-25.1 23.4-25.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTriangleExclamation = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;